import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CpaAccountsDialog } from '../core/dialogs/cpa-accounts-dialog/cpa-accounts-dialog.component';
import { ProductGroup } from '../core/models/product-group.model';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.css']
})
export class TitleComponent {

  selectedProductGroup: ProductGroup;

  private _productGroups: ProductGroup[];

  @Input() country: string;

  @Input() cpaName: string;

  @Input() cpaCode: string;

  @Input() locale: string;

  @Input() set productGroups(productGroups: ProductGroup[]) {
    this._productGroups = productGroups;
    if (productGroups.length > 0)
      this.selectedProductGroup = productGroups[0];
  }

  get productGroups(): ProductGroup[] {
    return this._productGroups;
  }

  @Output() productGroupSelected: EventEmitter<ProductGroup> = new EventEmitter<ProductGroup>();

  constructor(public dialog: MatDialog) { }

  onChange() {
    this.productGroupSelected.emit(this.selectedProductGroup);
  }

  onOpenCpaAccountsDialog() {
    this.dialog.open(CpaAccountsDialog, {
      data: {
        cpaCode: this.cpaCode,
        locale: this.locale
      },
      width: '500px'
    });
  }

  print() {

    var css = '@page { size: portrait; }',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style');

    style.type = 'text/css';
    style.media = 'print';

    // @ts-ignore
    if (style.styleSheet) {
      // @ts-ignore
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);

    window.print();
  }

}